import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Footer from '../components/footer'
import './index.css'
import 'semantic-ui-css/semantic.min.css'
import Navmenu from '../components/navmenu'
import favicon from '../assets/favicon.png'

const Layout = ({ children, data }) => (
  <div
    style={
      {
        // backgroundColor: '#fbfbfb'
      }
    }
  >
    <div
      style={{
        top: '-300px',
        // background: 'linear-gradient(to bottom right, #373B44, #4286f4)',
        background: '#091621',
        
        position: 'fixed',
        transform: 'skewY(-10deg)',

        height: 700,
        maxHeight: 700,
        width: '100%',
        zIndex: -3,
      }}
    />

    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        {
          name: 'keywords',
          content: 'Growth software, growth marketing, growth hacking',
        },
      ]}
      link={[{ rel: 'shortcut icon', type: 'image/png', href: `${favicon}` }]}
    />

    <Navmenu siteTitle={data.site.siteMetadata.title} />

    {/* <Pageheader /> */}
    {/* <br/> */}

    <div
      style={{
        margin: '0 auto',
        // maxWidth: 960,
        padding: '0px 1.0875rem 1.45rem',
        paddingTop: 0,
        //  marginTop: '4em',
        // backgroundColor: '#fbfbfb'
      }}
    >
      {children()}
    </div>
    <Footer />
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js